<p-toast></p-toast>

<div *ngIf="loading" style="text-align: center;">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
</div>

<suspend-user [userId]="userFeedbackDetail.RiderUserId" [userName]="userFeedbackDetail.DriverFullName" [_displayModalSuspend]="displayModalSuspend"
              (onChangedDisplayModalSuspend)="onChangedDisplayModalSuspend($event)"></suspend-user>

<div *ngIf="viewUserFeedbackDetail">
    <!--<div class="order-detail-title">
        <span class="order-detail-title__text">Complaint ID:</span>
        <span class="order-detail-title__id">{{feedbackId}}</span>
    </div>-->

    <p-scrollPanel [style]="{height: 'calc(100vh - 160px)'}">
        <p-card header="" [style]="{'box-shadow': 'none', 'border': '1px solid #0040604D', 'margin-top': '20px', 'margin-bottom': '20px'}">
            <ng-template pTemplate="header">
                <div class="flex justify-content-between od-card-header">
                    <span class="od-card-header-title">Complaint Detail</span>
                    <span class="od-card-header-status">{{userFeedbackDetail.StatusText}}</span>
                </div>
            </ng-template>
            <div class="flex flex-row">
                <div class="od-column od-name">Complaint time</div>
                <div class="od-column od-value">{{userFeedbackDetail.CreatedAt}}</div>
            </div>
            <div class="flex flex-row">
                <div class="od-column od-name">Complaint</div>
                <div class="od-column od-value">{{userFeedbackDetail.Feedback}}</div>
            </div>
        </p-card>

        <p-card header="" [style]="{'box-shadow': 'none', 'border': '1px solid #0040604D', 'margin-bottom': '20px'}">
            <ng-template pTemplate="header">
                <div class="flex justify-content-between od-card-header">
                    <span class="od-card-header-title">Ride detail</span>
                    <span class="od-card-header-svg">
                        <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                    </span>
                </div>
            </ng-template>
            <div class="flex flex-row">
                <div class="od-column od-name">Order time</div>
                <div class="od-column od-value">{{userFeedbackDetail.OrderTime}}</div>
            </div>
            <div class="flex flex-row">
                <div class="od-column od-name">Services type</div>
                <div class="od-column od-value">{{userFeedbackDetail.ServiceTypeText}}</div>
            </div>
            <div class="flex flex-row">
                <div class="od-column od-name">Pick up</div>
                <div class="od-column od-value">{{userFeedbackDetail.PickUp}}</div>
            </div>
            <div class="flex flex-row">
                <div class="od-column od-name">Destination</div>
                <div class="od-column od-value">{{userFeedbackDetail.Destination}}</div>
            </div>
            <div class="flex flex-row">
                <div class="od-column od-name">Value</div>
                <div class="od-column od-value">{{userFeedbackDetail.Amount}}</div>
            </div>
            <div class="flex flex-row">
                <div class="od-column od-name">Payment</div>
                <div class="od-column od-value">{{userFeedbackDetail.PaymentMethodText}}</div>
            </div>
            <div class="flex flex-row">
                <div class="od-column od-name">Promo</div>
                <div class="od-column od-value">{{userFeedbackDetail.PromoText}}</div>
            </div>
        </p-card>

        <p-card header="" [style]="{'box-shadow': 'none', 'border': '1px solid #0040604D', 'margin-bottom': '20px'}">
            <ng-template pTemplate="header">
                <div class="flex justify-content-between od-card-header">
                    <span class="od-card-header-title">Driver</span>
                    <span class="od-card-header-svg">
                        <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                    </span>
                </div>
            </ng-template>
            <div class="flex flex-row">
                <div class="od-column">
                    <div class="od-user-img">
                        <img src="{{userFeedbackDetail.DriverImageUrl}}" />
                    </div>
                </div>
                <div class="od-column">
                    <div class="flex flex-row">
                        <div class="od-column od-name">Full Name</div>
                        <div class="od-column od-value">{{userFeedbackDetail.DriverFullName}}</div>
                    </div>
                    <div class="flex flex-row">
                        <div class="od-column od-name">Gender</div>
                        <div class="od-column od-value">{{userFeedbackDetail.Gender}}</div>
                    </div>
                    <div class="flex flex-row">
                        <div class="od-column od-name">Phone</div>
                        <div class="od-column od-value">{{userFeedbackDetail.Phone}}</div>
                    </div>
                    <div class="flex flex-row">
                        <div class="od-column od-name">Email</div>
                        <div class="od-column od-value">{{userFeedbackDetail.Email}}</div>
                    </div>
                </div>
            </div>
        </p-card>
    </p-scrollPanel>

    <hr class="hr-filter" />
    <div class="flex justify-content-end  mrg-10-0px">
        <button class="btn-darkblue item-btn" pButton label="Close Complain" (click)="closeFeedback()"></button>
        <button class="btn-danger item-btn" pButton label="Suspend/Ban Driver" (click)="showModalSuspend()"></button>
    </div>
</div>